import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import formFieldsModule from "./Modules/formFieldsModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import rfaModule from "./Modules/rfaModule";
import evaluationsModule from "./Modules/evaluationsModule";

const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    rfaModule: rfaModule,
    uxModule: uxModule,
    formFieldsModule: formFieldsModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    evaluationsModule: evaluationsModule
  },

  state,
  mutations,
  actions
  //plugins: [
  //  createPersistedState({
  //    storage: window.sessionStorage,
  //  }),
  //],
});

export default store;
